import { Link } from 'react-router-dom';
import { type FeedItem } from '@/lib/api';
import { FishBadge } from '@/components/fish-badge';
import type { Grade } from '@fishymeter/types';

function timeAgo(isoString: string): string {
  const ms = Date.now() - new Date(isoString).getTime();
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(isoString).toLocaleDateString();
}

export interface FeedItemCardProps {
  item: FeedItem;
}

export function FeedItemCard({ item }: FeedItemCardProps) {
  return (
    <Link
      to={`/c/${item.analysis_id}`}
      className="block rounded-lg border border-border bg-card p-4 shadow-sm transition-shadow hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary"
    >
      <div className="flex items-start justify-between gap-3">
        {item.grade && <FishBadge grade={item.grade as Grade} size="sm" showGrade={false} />}
        {item.overall_score !== undefined && (
          <span className="font-mono text-xs text-muted-foreground">{item.overall_score}/100</span>
        )}
      </div>
      <h3 className="mt-3 font-semibold leading-snug line-clamp-2">
        {item.title ?? 'Untitled'}
      </h3>
      {item.verdict && (
        <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2">{item.verdict}</p>
      )}
      <p className="mt-3 text-xs text-muted-foreground">
        {item.username ? (
          <>
            metered by <span className="font-medium text-foreground">@{item.username}</span>
            <span> · </span>
          </>
        ) : null}
        {timeAgo(item.created_at)}
      </p>
    </Link>
  );
}
